import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiService } from './api.service';
import { FeatureDetail } from '../constants';
import { ItemPermissionsRequest, ItemPermissionsResponse } from '../interfaces';

/**
 * Batch per-item capability resolution — the fix for the all_items === false gap documented on
 * PermissionService.hasCapability. Thin passthrough, no internal cache: the list view queries a
 * varying uuid set per page/filter while the detail view queries one stable uuid per project
 * session — two different cache lifetimes, so caching is left to each caller. Fails open (HTTP
 * error → {}) so an OR-combined caller always falls back to its existing behavior instead of
 * hiding an action or erroring.
 */
@Injectable({ providedIn: 'root' })
export class ItemPermissionsService {
  private readonly api = inject(ApiService);

  public getItemPermissions(
    itemUuids: string[],
    featureDetailName: FeatureDetail
  ): Observable<ItemPermissionsResponse> {
    if (!itemUuids.length) {
      return of({});
    }
    const request: ItemPermissionsRequest = { itemUuids, featureDetailName };
    return this.api
      .httpPost('/api/permissions/items/permissions', request, false, true, undefined, { skipErrorHandling: true })
      .pipe(catchError(() => of({} as ItemPermissionsResponse)));
  }
}
